import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import VueMeta from 'vue-meta';
import router from './router'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
Vue.use(VueMeta);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
